export default {
  getControls: state => state.controls,
  getControlItem: state => key => state.controls[key],
  getFlags: state => state.flags,
  getFlag: state => key => state.flags[key],
};
